import { IEntityConfig, ENTITY_TYPES } from '@app/shared/types';

const entityType: ENTITY_TYPES = ENTITY_TYPES.TRANSFER;
const config: IEntityConfig = {
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  buttons: {},
  editor: {},
  needConvertTimeZoneFields: ['transaction_date'],
  apiEndpoint: entityType,
  uiRoute: entityType,
  isFormServiceSupported: true,
  entityNameToCheckPermissions: ENTITY_TYPES.TRANSFER,
  requiredPermissions: ['transfer.View'],
  list: {
    userGridOptions: {
      suppressRowClickSelection: true,
    },
    gridOptions: {
      valueField: '_id',
      disableColumnSelector: true,
      multiselect: false,
      disableUserViews: true,
      showViewSelector: false,
    },
    documentQuery: {
      orderby: 'start_date desc',
      notNeedActive: true,
      select: ['entity_id', 'site_ids'],
      check_is_removable: true,
    },
    documentOperationOptions: {
      skipMappers: true,
    },
    columns: [],
  },
};

export { entityType, config };
